import loadable from '@loadable/component';

const ShLoginModalLazy = loadable(
    () => import('../concrete/login-register-modals/shLoginModal')
)

export default ShLoginModalLazy;
